/* eslint-disable react/jsx-fragments */
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Button } from "antd";
import { RcFile } from "antd/es/upload";
import { useFormContext } from "react-hook-form";
import { s3AdapterApi } from "@entities/api";
import { uuidRegex } from "@shared/utils";
import { ObjectFormDate, ObjectFormInput, ObjectFormInputDate } from "..";
import { FormType } from "../../types/form-type";
import { DocumentSelector } from "../document-selector";

interface ObjectFormPermissionsBlockProps {
  index: number;
  remove: (index:number) => void;
  availableToRemove: boolean;
}

export function ObjectFormPermissionsBlock({
  index,
  remove,
  availableToRemove,
}: ObjectFormPermissionsBlockProps) {
  const { control, register, setValue, watch } = useFormContext<FormType>();

  const fileId = watch(`permissions.documentationPermissions.${index}.file.id`);

  // TODO: убарть когда s3 уберут из общего доступа.
  const { data: fileMeta } = useQuery({
    queryFn: () =>
      s3AdapterApi
        .post(`/files/meta`, [
          {
            fileNumber: 0,
            fileId,
          },
        ])
        .then((r) => r.data),
    queryKey: ["file", fileId, "meta"],
    enabled: uuidRegex.test(fileId ?? ""),
  });

  const { data: url } = useQuery({
    queryFn: () =>
      s3AdapterApi.get(`files/${fileId}?type=URL`).then((r) => r.data),
    queryKey: ["file", fileId, "url"],
    enabled: !!fileId,
  });

  useEffect(() => {
    register(`permissions.documentationPermissions.${index}.file` as const);
  }, []);

  useEffect(() => {
    register(
      `permissions.documentationPermissions.${index}.documentationPermissionId` as const,
    );
  }, []);

  const handleFileSelect = (file: RcFile) => {
    setValue(`permissions.documentationPermissions.${index}.file` as const, {
      file,
      id: file.uid,
    });
  };

  const handleFileRemove = () => {
    setValue(`permissions.documentationPermissions.${index}.file`, undefined);
  };

  return (
    <>
    {availableToRemove && 
      (
        <Button style={{ alignSelf:'end' }} type="dashed" icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4.5H12C12.2761 4.5 12.5 4.72386 12.5 5V13C12.5 13.8284 11.8284 14.5 11 14.5H5C4.17157 14.5 3.5 13.8284 3.5 13V5C3.5 4.72386 3.72386 4.5 4 4.5Z" stroke="#333333"/>
          <rect x="2.5" y="2.5" width="11" height="2" rx="0.5" stroke="#333333"/>
          <rect x="7" y="7" width="5" height="1" rx="0.5" transform="rotate(90 7 7)" fill="#333333"/>
          <rect x="10" y="7" width="5" height="1" rx="0.5" transform="rotate(90 10 7)" fill="#333333"/>
          <rect x="5.5" y="0.5" width="5" height="2" rx="0.5" stroke="#333333"/>
          </svg>} onClick={()=> remove(index)}/>
      )
    }
      <ObjectFormInputDate<FormType>
        nameFirst={`permissions.documentationPermissions.${index}.number`}
        nameSecond={`permissions.documentationPermissions.${index}.date`}
        control={control}
        labelFirst="№ разрешения"
        labelSecond="Дата выдачи"
        placeholderFirst=""
        placeholderSecond=""
        // errorMessage={errors?.permitNumber?.message}
      />
      <ObjectFormInput
        name={`permissions.documentationPermissions.${index}.issued`}
        control={control}
        label="Наименование органа, выдавшего разрешение"
      />
      <ObjectFormDate
        nameFirst={`permissions.documentationPermissions.${index}.expiryDate`}
        nameSecond={`permissions.documentationPermissions.${index}.prolongDate`}
        control={control}
        labelFirst="Срок действия (необязательно)"
        labelSecond="Продлен до (необязательно)"
      />
      <DocumentSelector
        accept={["application/pdf"]}
        extensions={["pdf"]}
        label="Прикрепите документ"
        onFileRemove={handleFileRemove}
        onFileSelect={handleFileSelect}
        defaultFileName={fileMeta?.[0]?.fileName}
        defaultFileSize={fileMeta?.[0]?.fileContentLength}
        defaultFileLink={url?.content}
      />
      <div className="dottedLine" />
    </>
  );
}
